import { convertFortimeCategory } from "./converters";
import { FortimeCategory } from "./types";
import { BaseCategoriesClient, BaseClientResponse } from "@core/types";

const CATEGORIES_PER_PAGE = 100;

class CategoriesClient extends BaseCategoriesClient {
  async getAllCategories() {
    let page = 1;
    let response: BaseClientResponse<FortimeCategory[]>;
    let allCategories: FortimeCategory[] = [];
    do {
      response = await this.instance.get<FortimeCategory[]>("/wp-json/wc/v3/products/categories", {
        params: {
          per_page: CATEGORIES_PER_PAGE,
          page: page,
        },
      });
      page++;
      allCategories = [...allCategories, ...response.data];
    } while (response.data.length >= 100);

    const allCat = allCategories.map(convertFortimeCategory);
    const subCategories = allCat.filter((x) => x.parent !== "0");
    const mainCategories = allCat.filter((x) => x.parent === "0");

    return { allCategories: allCat, subCategories, mainCategories };
  }

  async getMainCategories() {
    const response = await this.instance.get<FortimeCategory[]>("/wp-json/wc/v3/products/categories", {
      params: {
        per_page: CATEGORIES_PER_PAGE,
        parent: "0",
      },
    });
    return response.data.map(convertFortimeCategory);
  }

  async getSubCategories(id: string) {
    const response = await this.instance.get<FortimeCategory[]>("/wp-json/wc/v3/products/categories", {
      params: {
        per_page: CATEGORIES_PER_PAGE,
        parent: id,
      },
    });
    return response.data.map(convertFortimeCategory);
  }

  async getCategoryById(id: string) {
    const response = await this.instance.get<FortimeCategory[]>(`/wp-json/wc/v3/products/categories?include=${id}`);
    return !!response?.data?.length ? convertFortimeCategory(response.data[0]) : null;
  }
}

export default CategoriesClient;
